import React from 'react';
interface SectionRevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}
// Animations removed — render content immediately, always visible.
// This guarantees the page never goes black due to opacity/animation timing.
export function SectionReveal({
  children,
  className = ''
}: SectionRevealProps) {
  return <div className={className} data-id="element-243">{children}</div>;
}
export function StaggerContainer({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={className} data-id="element-244">{children}</div>;
}
export function StaggerItem({
  children,
  className = ''
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={className} data-id="element-245">{children}</div>;
}